var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuildCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "build-circle",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8.011,8.011,0,0,1,12,20Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.49,11.38A3.459,3.459,0,0,0,8.58,7.17l2.35,2.35L9.52,10.93,7.17,8.58a3.459,3.459,0,0,0,4.21,4.91l3.41,3.41a.5.5,0,0,0,.71,0l1.4-1.4a.5.5,0,0,0,0-.71Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildCircle);
export default __webpack_public_path__ + "static/media/build-circle.33adc57af71d7c8c097dee0dffc6280d.svg";
export { ForwardRef as ReactComponent };